// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".debuggerStatusbar--1hWqH29Z {\n  display: grid;\n  color: var(--antd-text-color);\n  background-color: #1e1e1e;\n  padding: 4px 0;\n}\n\n.coverage--3AQegOyA {\n  padding: 0 8px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.coverageIcon--28zB4E5h {\n  margin-right: 0.5em;\n}\n\n.hasFailedTests--2r5zDfBR,\n.coverageFailed--1BcyRWMm,\n.coverageLow--3l3YxbjG {\n  color: var(--tag-red-color);\n}\n\n.coverageMedium--3SjG5MTj {\n  color: var(--tag-orange-color);\n}\n\n.coverageHigh--3EKdqa1K {\n  color: var(--tag-yellow-color);\n}\n\n.coverageFull--1b-u6n2f {\n  color: var(--tag-green-color);\n}\n\n.subCoverage--1oV0_8K8 {\n  margin-left: 1em;\n  color: var(--text-color-disabled);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debuggerStatusbar": "debuggerStatusbar--1hWqH29Z",
	"coverage": "coverage--3AQegOyA",
	"coverageIcon": "coverageIcon--28zB4E5h",
	"hasFailedTests": "hasFailedTests--2r5zDfBR",
	"coverageFailed": "coverageFailed--1BcyRWMm",
	"coverageLow": "coverageLow--3l3YxbjG",
	"coverageMedium": "coverageMedium--3SjG5MTj",
	"coverageHigh": "coverageHigh--3EKdqa1K",
	"coverageFull": "coverageFull--1b-u6n2f",
	"subCoverage": "subCoverage--1oV0_8K8"
};
export default ___CSS_LOADER_EXPORT___;
